import helpers from "./app.js";
export default Vue => {
  Object.defineProperties(Vue.prototype, {
    $helpers: {
      get() {
        return helpers;
      }
    }
  });
};
